module.exports = __webpack_public_path__ + "static/media/nvshen-meizhuang.3c18b078.png";